module.exports = __webpack_public_path__ + "static/media/eduma.dc5f3de9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/devdata/resources/sponsors/eduma.jpg
// module id = 477
// module chunks = 0